export enum FilterTabs {
    SETTINGS = 'settings',
    TILES = 'tiles',
}

export const DEFAULT_TAB = FilterTabs.SETTINGS;

export enum FilterActions {
    ADD = 'add',
    REMOVE = 'remove',
}
